import { useState } from 'react';

const useModal = () => {
  const [isOpenModal, setModalOpen] = useState(false);
  const [isOpenpassModal, setpassModalOpen] = useState(false);

  const onOpenModal = () => {
    setModalOpen(true);
  };

  const onCloseModal = () => {
    setModalOpen(false);
  };



  const onOpenpassModal = () => {
    setpassModalOpen(true);
  };

  const onClosepassModal = () => {
    setpassModalOpen(false);
  };


  return { isOpenModal, isOpenpassModal ,onOpenpassModal,onClosepassModal,onOpenModal, onCloseModal };
};

export default useModal;
